import { render, staticRenderFns } from "./ShippoFeeType.vue?vue&type=template&id=66dfe434&"
import script from "./ShippoFeeType.vue?vue&type=script&lang=ts&"
export * from "./ShippoFeeType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports